// Build-time feature flags. Read from REACT_APP_* env vars, which Create React App
// inlines at build time - so a flag that is false becomes a literal `false` and any
// code branch behind it is dead-code-eliminated from the production bundle.
//
// RAG surface (the /rag assessment page and /chat page) ships DISABLED. It stays
// out of the build and unreachable until the RAG backend is live on EC2. To turn it
// on later: set REACT_APP_ENABLE_RAG=true (in .env.production / the build env) and
// add its nav link. See src/config/routesConfig.jsx for the gated routes.
export const RAG_ENABLED = process.env.REACT_APP_ENABLE_RAG === "true";
